import { createRouter, createWebHistory } from 'vue-router';
import Dashboard from '@/pages/Dashboard.vue';
import Login from '@/pages/Login.vue';
import Analytics from '@/pages/Analytics.vue';
import ProductList from '@/pages/ProductList.vue';
import UserProfile from '@/pages/UserProfile.vue';
import TiposComponente from '@/pages/catalogos/TiposComponente.vue';
import Seccion from '@/pages/catalogos/Seccion.vue';
import Componente from '@/pages/catalogos/Componente.vue';
import SeccionComponente from '@/pages/catalogos/SeccionComponente.vue';
import Contactos from '@/pages/catalogos/Contactos.vue';
import Fracciones from '@/pages/catalogos/Fracciones.vue';
import UsosCfdi from '@/pages/catalogos/UsosCfdi.vue';
import TiposPago from '@/pages/catalogos/TiposPago.vue';
import FormasPago from '@/pages/catalogos/FormasPago.vue'
import Proveedores from '@/pages/catalogos/Proveedores.vue';
import CatalogosNew from '@/pages/catalogos/CatalogosNew.vue';
import TiposComponenteNew from '@/pages/catalogos/TiposComponenteNew.vue';
import CatalogosGestion from '@/pages/catalogos/CatalogosGestion.vue';
import CatalogosGestionCompleta from '@/pages/catalogos/CatalogosGestionCompleta.vue';
import CamposCatalogoNew from '@/pages/catalogos/CamposCatalogoNew.vue';
import SeccionesNew from '@/pages/catalogos/SeccionesNew.vue';
import SeccionTipoComponenteNew from '@/pages/catalogos/SeccionTipoComponenteNew.vue';
import SeccionCatalogoGestion from '@/pages/catalogos/SeccionCatalogoGestion.vue';
import PrototiposNewList from '@/pages/catalogos/PrototiposNewList.vue';
import PrototiposNewForm from '@/pages/catalogos/PrototiposNewForm.vue';
import NegocioSelector from '@/components/NegocioSelector.vue';
import AdminUsers from '@/pages/admin/AdminUsers.vue';
import AdminNegocios from '@/pages/admin/AdminNegocios.vue';
import AdminUsuarioNegocio from '@/pages/admin/AdminUsuarioNegocio.vue';
import AdminUsuarioNegocioV2 from '@/pages/admin/AdminUsuarioNegocioV2.vue';
import AdminUsuarioNegocioV3 from '@/pages/admin/AdminUsuarioNegocioV3.vue';
import AdminRolesSecciones from '@/pages/admin/AdminRolesSecciones.vue';
import Prototipos from '@/pages/Prototipos.vue';
import PrototipoForm from '@/pages/PrototipoForm.vue';
import Cotizaciones from '@/pages/Cotizaciones.vue';
import CotizacionForm from '@/pages/CotizacionForm.vue';
import CotizacionesDashboard from '@/pages/cotizaciones/CotizacionesDashboard.vue';
import Pedidos from '@/pages/Pedidos.vue';
import PedidoDetalle from '@/pages/PedidoDetalle.vue';
import PedidoForm from '@/pages/PedidoForm.vue';
import TableroFinanciero from '@/components/Finanzas/Tablero/TableroFinanciero.vue';
import ListaCuentasBancarias from '@/components/Finanzas/CuentasBancarias/ListaCuentasBancarias.vue';
import ListaCategorias from '@/components/Finanzas/Categorias/ListaCategorias.vue';
import Ingresos from '@/components/Finanzas/Ingresos/ListaIngresos.vue';
import Gastos from '@/components/Finanzas/Egresos/ListaEgresos.vue';
import Transferencias from '@/components/Finanzas/Movimientos/Transferencias.vue';
import ListaCuentasPorCobrar from '@/components/Finanzas/CuentasPorCobrar/ListaCuentasPorCobrar.vue';
import ListaCuentasPorPagar from '@/components/Finanzas/CuentasPorPagar/ListaCuentasPorPagar.vue';
import FlujoCaja from '@/components/Finanzas/FlujoCaja/FlujoCaja.vue';
import ListaPresupuestos from '@/components/Finanzas/Presupuestos/ListaPresupuestos.vue';
import Reportes from '@/components/Finanzas/Reportes/Reportes.vue';
import Configuracion from '@/components/Finanzas/Configuracion/Configuracion.vue';

// Inventario
import CatalogoProductos from '@/components/Inventario/Productos/CatalogoProductos.vue';
import CatalogoMateriasPrimas from '@/components/Inventario/Materias/CatalogoMateriasPrimas.vue';
import EntradasInventario from '@/components/Inventario/Movimientos/EntradasInventario.vue';
import SalidasInventario from '@/components/Inventario/Movimientos/SalidasInventario.vue';
import Ajustes from '@/components/Inventario/Movimientos/Ajustes.vue';
import CatalogoProveedores from '@/components/Inventario/Proveedores/CatalogoProveedores.vue';
import ReportesInventario from '@/components/Inventario/Reportes/ReportesInventario.vue';
import ConfiguracionInventario from '@/components/Inventario/Configuracion/ConfiguracionInventario.vue';

// POS2
import Pos2TiposComponente from '@/views/Pos2/TiposComponente.vue'
import Pos2Departamentos from '@/views/Pos2/Departamentos.vue'
import Pos2UnidadesMedida from '@/views/Pos2/UnidadesMedida.vue'
import Pos2Productos from '@/views/Pos2/Productos.vue'
import Pos2Proveedores from '@/views/Pos2/Proveedores.vue'
import Pos2Categorias from '@/views/Pos2/Categorias.vue'
import Pos2TiposMaterial from '@/views/Pos2/TiposMaterial.vue'
import Pos2TiposPapel from '@/views/Pos2/TiposPapel.vue'
import Pos2TiposCliente from '@/views/Pos2/TiposCliente.vue'
import Pos2Plantas from '@/views/Pos2/Plantas.vue'
import Pos2Empleados from '@/views/Pos2/Empleados.vue'
import Pos2Clientes from '@/views/Pos2/Clientes.vue'
import Pos2EsquemasFacturacion from '@/views/Pos2/EsquemasFacturacion.vue'
import Pos2Disenadores from '@/views/Pos2/Disenadores.vue'
import Pos2ListaPedidos from '@/views/Pos2/ListaPedidos.vue'
import Pos2CrearPedido from '@/views/Pos2/CrearPedido.vue'
import Pos2ListaOrdenesProduccion from '@/views/Pos2/ListaOrdenesProduccion.vue'
import Pos2ListaNotas from '@/views/Pos2/ListaNotas.vue'
import Pos2ListaFacturas from '@/views/Pos2/ListaFacturas.vue'

// Ventas
import PuntoVenta from '@/components/Ventas/Comandas/PuntoVenta.vue';
import HistorialVentas from '@/components/Ventas/Comandas/HistorialVentas.vue';
import CortesCaja from '@/components/Ventas/Cajas/CortesCaja.vue';
import ReportesVentas from '@/components/Ventas/Reportes/ReportesVentas.vue';

// Herramientas
import CalculadoraPrecios from '@/components/Herramientas/CalculadoraPrecios.vue';

import { getToken } from '@/utils/auth';
import { useUserStore } from '@/stores/user';

const routes = [
  { path: '/login', component: Login, meta: { layout: 'public' } },
  { path: '/seleccionar-negocio', component: NegocioSelector, meta: { requiresAuth: true, layout: 'public' } },
  { path: '/dashboard', component: Dashboard, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/analytics', component: Analytics, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/products', component: ProductList, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/profile', component: UserProfile, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/admin/users', component: AdminUsers, meta: { requiresAuth: true, requiresSuper: true } },
  { path: '/tipos-componente', component: TiposComponente, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/secciones', component: Seccion, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/componentes', component: Componente, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/seccion-componente', component: SeccionComponente, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/contactos', component: Contactos, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/fracciones', component: Fracciones, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/usos-cfdi', component: UsosCfdi, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/tipos-pago', component: TiposPago, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/formas-pago', component: FormasPago, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/proveedores', component: Proveedores, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/tipos-componente-new', component: TiposComponenteNew, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/catalogos-gestion', component: CatalogosGestion, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/catalogos-gestion-completa', component: CatalogosGestionCompleta, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/campos-catalogo-new', component: CamposCatalogoNew, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/catalogos-new', component: CatalogosNew, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/secciones-new', component: SeccionesNew, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/seccion-catalogo-gestion', component: SeccionCatalogoGestion, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/seccion-tipo-componente-new', component: SeccionTipoComponenteNew, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/prototipos-new/nuevo', component: PrototiposNewForm, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/prototipos-new/:id/editar', component: PrototiposNewForm, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/prototipos-new', component: PrototiposNewList, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/prototipos', component: Prototipos, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/prototipos/nuevo', component: PrototipoForm, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/prototipos/:id/editar', component: PrototipoForm, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/cotizaciones/dashboard', component: CotizacionesDashboard, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/cotizaciones', component: Cotizaciones, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/cotizaciones/nueva', component: CotizacionForm, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/cotizaciones/:id/editar', component: CotizacionForm, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/cotizaciones/:id', component: CotizacionForm, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pedidos', component: Pedidos, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pedidos/nuevo', component: PedidoForm, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pedidos/:id', component: PedidoDetalle, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/admin/negocios', component: AdminNegocios, meta: { requiresAuth: true, requiresSuper: true } },
  { path: '/admin/usuario-negocio', component: AdminUsuarioNegocio, meta: { requiresAuth: true, requiresSuper: true } },
  { path: '/admin/usuario-negocio-v2', component: AdminUsuarioNegocioV2, meta: { requiresAuth: true, requiresSuper: true } },
  { path: '/admin/usuario-negocio-v3', component: AdminUsuarioNegocioV3, meta: { requiresAuth: true, requiresSuper: true } },
  { path: '/admin/roles-secciones', component: AdminRolesSecciones, meta: { requiresAuth: true, requiresSuper: true } },

  // ========================================
  // CONTROL FINANCIERO - Módulo de Finanzas
  // ========================================
  { path: '/finanzas/tablero', component: TableroFinanciero, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/finanzas/cuentas-bancarias', component: ListaCuentasBancarias, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/finanzas/categorias', component: ListaCategorias, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/finanzas/movimientos/ingresos', component: Ingresos, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/finanzas/movimientos/gastos', component: Gastos, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/finanzas/movimientos/transferencias', component: Transferencias, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/finanzas/cuentas-por-cobrar', component: ListaCuentasPorCobrar, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/finanzas/cuentas-por-pagar', component: ListaCuentasPorPagar, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/finanzas/flujo-caja', component: FlujoCaja, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/finanzas/presupuestos', component: ListaPresupuestos, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/finanzas/reportes', component: Reportes, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/finanzas/configuracion', component: Configuracion, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/finanzas', redirect: '/finanzas/tablero' },

  // ========================================
  // GESTIÓN DE INVENTARIO Y COSTOS
  // ========================================
  { path: '/inventario/productos', component: CatalogoProductos, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/inventario/materias-primas', component: CatalogoMateriasPrimas, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/inventario/entradas', component: EntradasInventario, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/inventario/salidas', component: SalidasInventario, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/inventario/ajustes', component: Ajustes, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/inventario/proveedores', component: CatalogoProveedores, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/inventario/reportes', component: ReportesInventario, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/inventario/configuracion', component: ConfiguracionInventario, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/inventario', redirect: '/inventario/productos' },

  // ========================================
  // PUNTO DE VENTA Y GESTIÓN DE VENTAS
  // ========================================
  { path: '/ventas/punto-venta', component: PuntoVenta, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/ventas/historial', component: HistorialVentas, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/ventas/cortes-caja', component: CortesCaja, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/ventas/reportes', component: ReportesVentas, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/ventas', redirect: '/ventas/punto-venta' },

  // ========================================
  // POS2
  // ========================================
  { path: '/pos2/tipos-componente', component: Pos2TiposComponente, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pos2/departamentos', component: Pos2Departamentos, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pos2/unidades-medida', component: Pos2UnidadesMedida, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pos2/productos', component: Pos2Productos, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pos2/proveedores', component: Pos2Proveedores, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pos2/categorias', component: Pos2Categorias, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pos2/tipos-material', component: Pos2TiposMaterial, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pos2/tipos-papel', component: Pos2TiposPapel, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pos2/tipos-cliente', component: Pos2TiposCliente, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pos2/plantas', component: Pos2Plantas, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pos2/empleados', component: Pos2Empleados, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pos2/clientes', component: Pos2Clientes, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pos2/esquemas-facturacion', component: Pos2EsquemasFacturacion, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pos2/disenadores', component: Pos2Disenadores, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pos2/pedidos', component: Pos2ListaPedidos, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pos2/pedidos/nuevo', component: Pos2CrearPedido, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pos2/pedidos/:id/editar', component: Pos2CrearPedido, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pos2/ordenes-produccion', component: Pos2ListaOrdenesProduccion, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pos2/notas', component: Pos2ListaNotas, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pos2/facturas', component: Pos2ListaFacturas, meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/pos2', redirect: '/pos2/tipos-componente' },

  // ========================================
  // HERRAMIENTAS
  // ========================================
  { path: '/herramientas/calculadora-precios', component: CalculadoraPrecios, meta: { requiresAuth: true, requiresBusiness: true } },

  // ========================================
  // PRODUCCIÓN - Órdenes de Producción
  // ========================================
  { path: '/produccion/ordenes', component: () => import('@/components/Produccion/ListaOrdenesProduccion.vue'), meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/produccion/dashboard', component: () => import('@/views/Produccion/DashboardProduccion.vue'), meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/produccion/tracker', component: () => import('@/views/Produccion/TrackerProduccion.vue'), meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/produccion/mi-monitor', name: 'MiMonitor', component: () => import('@/views/Produccion/MiMonitor.vue'), meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/produccion/monitor-general', name: 'MonitorGeneral', component: () => import('@/views/Produccion/MonitorGeneral.vue'), meta: { requiresAuth: true, requiresBusiness: true } },
  { path: '/produccion', redirect: '/produccion/ordenes' },

  { path: '/', redirect: '/dashboard' }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const token = getToken();
  
  // Check authentication first
  if (to.meta.requiresAuth && !token) {
    next('/login');
    return;
  }
  
  // For authenticated users, handle business selection logic
  if (token) {
    const userStore = useUserStore();
    
    // Special handling for business selector route
    if (to.path === '/seleccionar-negocio') {
      // Super Admin can always access business selector
      if (userStore.isSuper) {
        next();
        return;
      }
      // For regular users, if business is already selected, redirect to dashboard
      if (userStore.negocioSeleccionado) {
        next('/dashboard');
        return;
      }
      // If no business selected, allow access to selector
      next();
      return;
    }
    
    // For routes that require business selection
    if (to.meta.requiresBusiness) {
      // If no business is selected, redirect to selector
      if (!userStore.negocioSeleccionado) {
        next('/seleccionar-negocio');
        return;
      }
    }
    
    // For routes that require Super admin privileges
    if (to.meta.requiresSuper) {
      if (!userStore.isSuper) {
        // Redirect non-super users to dashboard or show error
        next('/dashboard');
        return;
      }
    }
  }
  
  next();
});

export default router; 